import { productImportRuns } from '../productImportRun'
import { describeTable } from './describeTable'

describeTable(productImportRuns, {
  description: `One execution of the supplier catalog import (Onninen from LVISNet). A scheduled job checks daily at 10:00 Helsinki and imports when the supplier has published a newer catalog. Each run upserts the supplier's rows in products at the default markup floor and soft-deletes the products missing from the catalog.`,
  columns: {
    supplier: "Supplier name as in products.supplier, e.g. 'Onninen'.",
    status: "'running' while in progress, then 'done' or 'failed'.",
    catalogPublishedAt:
      'When the supplier published the catalog this run imported (newest file in LVISNet).',
    counts:
      'JSON: inserted, updated and deleted products, and byChangeType (new, price_updated, markup_preserved, price_pinned_kept, price_pinned_raised, deleted).',
    reportStorageKey:
      'S3 key of the xlsx change report in the private bucket; null when the run failed before writing it.',
    error: 'Error text when status is failed.',
  },
})
